import * as React from 'react'
import { useRouter } from 'next/router'
import { NextSeo, BreadcrumbJsonLd, CourseJsonLd } from 'next-seo'

import Routes, { toAbsoluteUrl } from 'utils/routes'
import { Path } from 'types/types'

const SEO = ({ path }: { path: Path }) => {
    const router = useRouter()

    const keywords = [
        'corso di programmazione gratis',
        'diventare programmatore',
        ...path.categories.map((c) => c.title),
    ]

    const caption = path.goal === 'career' ? 'PERCORSO DI CARRIERA' : 'PERCORSO GRATIS'

    return (
        <>
            <NextSeo
                title={path.title}
                titleTemplate={'%s | Devv'}
                description={path.description}
                canonical={`${toAbsoluteUrl(router.asPath)}`}
                additionalMetaTags={[
                    {
                        property: 'keywords',
                        content: keywords.join(', '),
                    },
                ]}
                openGraph={{
                    url: `${toAbsoluteUrl(router.asPath)}`,
                    images: [
                        {
                            url: Routes.OGImageTitleCTA(path.title, caption),
                            secureUrl: Routes.OGImageTitleCTA(path.title, caption),
                            type: 'image/png',
                            width: 1200,
                            height: 630,
                            alt: path.title,
                        },
                    ],
                }}
            />
            <BreadcrumbJsonLd
                itemListElements={[
                    {
                        position: 1,
                        name: 'Catalogo Corsi',
                        item: `${toAbsoluteUrl(Routes.Catalog)}`,
                    },
                    {
                        position: 2,
                        name: path.title,
                        item: `${toAbsoluteUrl(Routes.Course(path.slug))}`,
                    },
                ]}
            />
            <CourseJsonLd
                courseName={path.title}
                description={path.short_description}
                provider={{
                    name: 'Devv',
                    url: `${process.env.NEXT_PUBLIC_DEVV_WEBAPP_URL}`,
                }}
            />
        </>
    )
}

export default SEO
